import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { createSundryTransaction, fetchSundryItems } from '../../../store/actions/sundriesActions';
import { ERROR } from '../../../store/types';
import RadioGroup from '../../elements/form/RadioGroup';
import NumberField from '../../elements/form/NumberField';
import ModalActionButton from '../../elements/ModalActionButton';
import TextField from '../../elements/form/TextField';
import AutocompleteSelect from '../../elements/form/AutocompleteSelect';
import TrashIcon from '../../elements/icons/TrashIcon';
import PlusIcon from '../../elements/icons/PlusIcon';
import DateField from '../../elements/form/DateField';
import moment from 'moment';

const NewSundryTransaction = ({account, close}) => {
    const [transactionPayload, setTransactionPayload] = useState({account: account._id});
    const dispatch = useDispatch()
    const sundriesSelector = useSelector(state => state.sundries)

    // useMemo
    // const chargeItem = 
    useEffect(() => {
        dispatch(fetchSundryItems('', 0, 0))
        if(transactionPayload.type === 'charge'){
            setChargeItems([{
                item: null,
                amount: 0,
                quantity: 1,
                total: 0
            }])
        }
        return () => {
            
        };
    }, [dispatch, transactionPayload.type]);

    const transactionTypes = [
        {
        label: 'Funding',
        value: 'funding'
        },
        {
        label: 'Charge/Expense',
        value: 'charge'
        }
    ]

    const [chargeItems, setChargeItems] = useState([]);

    const [validationErrors, setValidationErrors] = useState({})

    const validateForm = () => {
        let errors = {}
        if(transactionPayload.type === 'funding' && (!transactionPayload.amount || transactionPayload.amount < 1)){
            errors.amount = true
        }
        if(!transactionPayload.transactionDate || transactionPayload.transactionDate === ''){
            errors.transactionDate = true
        }
        if(!transactionPayload.type || transactionPayload.type === ''){
            errors.type = true
        }
        if(transactionPayload.type === 'charge' && (!chargeItems.length === 0)){
            errors.items = true
        }
        if(chargeItems > 0) {
            chargeItems.forEach((item, itemIndex) => {
                if(!item.item || item.item === ''){
                    errors[`items-item-${itemIndex}`] = true
                }
                if(!item.quantity || item.quantity < 1){
                    errors[`items-qty-${itemIndex}`] = true
                }
            })
        }
        console.log('validation errors: ', errors)
        setValidationErrors(errors)
        return errors
    }

    const addItem = () => {
        const temp = [...chargeItems]
        temp.push({
            item: null,
            quantity: 1,
            total: 0
        })
        setChargeItems(temp)
    }
    
    const removeItem = (index) => {
        const temp = [...chargeItems]
        temp.splice(index, 1)
        setChargeItems(temp)
    }

    const updateExpenseItem = (index, field, value) => {
        const temp = [...chargeItems];
        const item = temp[index];

        if (!item) return;

        // Update fields
        if (field === 'item') {
            item.item = value;
            const isFixed = value.amountType === 'fixed';
            item.amount = isFixed ? +value.amount || 0 : item.amount || 0; // preserve editable amount if not fixed
        }

        if (field === 'amount') {
            item.amount = +value || 0;
        }

        if (field === 'quantity') {
            item.quantity = +value || 0;
        }

        // Always recalculate total if amount & quantity are available
        const amount = +item.amount || 0;
        const quantity = +item.quantity || 0;

        item.total = amount * quantity;

        setChargeItems(temp);
    }

    const transactionTotal = () => {
        return chargeItems.reduce((sum, item) => {
            return sum + (+item.total || 0);
        }, 0)
    }

    const pushTransaction = () => {

        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }
        dispatch(createSundryTransaction({
            ...transactionPayload, 
            items: chargeItems ? chargeItems.map(item => ({
                ...item,
                item: item?.item?._id
            })) : undefined,
            amount: transactionPayload.type === 'charge' ? transactionTotal() * 100 : transactionPayload.amount * 100
        }))
    }

    return (
        <div className='w-full'>
            <div className='mt-2'>
                <RadioGroup 
                    items={transactionTypes} 
                    inline={true}
                    preSelectedIndex={''}
                    inputLabel={'Transaction Type'}
                    requiredField={true}
                    returnSelected={(value) => {setTransactionPayload({...transactionPayload, ...{type: value.value}})}} 
                    hasError={validationErrors && validationErrors.type}  
                    titleField='label'
                />
            </div>

            <div className='mt-2 w-full'>
                <DateField
                    inputLabel="Transaction Date" 
                    fieldId="transaction-date" 
                    requiredField={true}
                    inputType="text" 
                    preloadValue={(moment(transactionPayload.transactionDate).format('YYYY-MM-DD')) || ''}
                    hasError={validationErrors && validationErrors.transactionDate} 
                    returnFieldValue={(value)=>{
                        setTransactionPayload({...transactionPayload, ...{transactionDate: new Date(value)}})
                    }}
                />
            </div>

            {transactionPayload.type === 'funding' && <div className='mt-2'>
                <NumberField
                    inputType="number" 
                    fieldId={`funding-amount`}
                    inputLabel="Funding Amount" 
                    inputPlaceholder={`How much is being added?`}
                    requiredField={true}
                    preloadValue={''}
                    hasError={validationErrors.score} 
                    returnFieldValue={(value)=> {setTransactionPayload({...transactionPayload, ...{amount: value}})}} 
                />
            </div>}

            {transactionPayload.type === 'charge' && <div className='mt-2'>
                {(!sundriesSelector.sundryItems.items || sundriesSelector.sundryItems?.items?.length === 0) && 
                    <div className='w-full rounded-[8px] border border-gray-300 bg-gray-100 text-xs p-[15px]'>
                        <p className='font-space-grotesk text-[14px] mb-[5px] font-[550]'>No sundry items found</p>
                        <p>Expenses must be on sundry Items, so you need to create sundry items before you can create a sundry expense</p>
                    </div>
                }
                {sundriesSelector.sundryItems.items?.length > 0 && 
                    <>
                    {chargeItems?.map((item, itemIndex)=>(
                        <div key={itemIndex} className='w-full bg-gray-50 rounded border border-gray-200 p-[15px] relative mb-[10px]'>
                            {itemIndex > 0 && <button onClick={()=>{removeItem(itemIndex)}} className='absolute top-[5px] right-[5px] p-1 rounded bg-transparent mb-[10px] hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                                <TrashIcon className={`w-[20px] h-[20px]`} />
                            </button>}
                            <div className='w-full'>
                                <AutocompleteSelect
                                    selectOptions={sundriesSelector?.sundryItems?.items}
                                    inputLabel="Expense Item"
                                    placeholderText={`Select an item`}
                                    titleField="itemName"
                                    displayImage={false}
                                    imageField=""
                                    requiredField={true}
                                    // preSelected={ null }
                                    // preSelectedLabel="_id"
                                    fieldId={`item-${itemIndex}-select`}
                                    position='top-[50px]'
                                    hasError={validationErrors && validationErrors[`items-${itemIndex}-item`]}
                                    // return id of accounts of the selected option
                                    returnFieldValue={(value) => {
                                        updateExpenseItem(itemIndex, 'item', value)
                                    }}
                                /> 
                            </div>
                            <div className='w-full flex items-end gap-x-[10px] mt-[10px]'>
                                <div className='w-4/12'>
                                    {/* {item?.item?.amountType === 'fixed' ? <p className='text-sm font-space-grotesk p-[15px]'>{(item.amount).toLocaleString()}</p>
                                    : */}
                                    <NumberField
                                        inputType="number" 
                                        fieldId={`item-${itemIndex}-amount`}
                                        inputLabel="Item Price" 
                                        inputPlaceholder={'Item amount'}
                                        requiredField={true}
                                        preloadValue={item?.amount || ''}
                                        hasError={validationErrors && validationErrors[`item-${itemIndex}-amount`]} 
                                        returnFieldValue={(value)=>{
                                            updateExpenseItem(itemIndex, 'amount', value)
                                        }}
                                    />
                                    {/* } */}
                                </div>
                                <div className='w-4/12'>
                                    <NumberField
                                        inputPlaceholder={'Quantity'}
                                        inputType="number" 
                                        fieldId={`item-${itemIndex}-quantity`}
                                        inputLabel="Item Quantity" 
                                        requiredField={true}
                                        preloadValue={item.quantity || ''}
                                        hasError={validationErrors && validationErrors[`item-${itemIndex}-quantity`]} 
                                        returnFieldValue={(value)=>{
                                            updateExpenseItem(itemIndex, 'quantity', value)
                                        }}
                                    />
                                </div>
                                <div className='w-4/12 text-right'>
                                    <p className='text-sm font-space-grotesk mt-[5px] py-[15px]'>₦{(item?.total).toLocaleString() || 0}</p>
                                </div>
                            </div>
                        </div>
                    ))}

                    <div className='w-full p-[10px] bg-gray-50 text-right rounded my-[5px]'>
                        <h3 className='font-space-grotesk text-lg font-[550]'>
                            ₦{transactionTotal().toLocaleString()}
                        </h3>
                    </div>

                    <button onClick={()=>{addItem()}} className='w-full border-[1.5px] border-dashed px-[15px] py-[12px] mt-[10px] rounded-[8px] bg-white text-gray-600 border-gray-400 font-[550] font-space-grotesk text-sm flex items-center justify-center gap-x-[5px] transition duration-200 hover:bg-gray-100'>
                        <PlusIcon className="w-4 he-4" />
                        Add Expense Item
                    </button>
                    </>
                }
            </div>}

            <div className='mt-2'>
                <TextField
                    inputLabel="Remarks" 
                    fieldId="transaction-remarks" 
                    inputType="text" 
                    requiredField={false}
                    inputPlaceholder={`Add any remarks for this transaction if needed`}
                    preloadValue={''}
                    hasError={validationErrors && validationErrors.description} 
                    returnFieldValue={(value)=>{setTransactionPayload({...transactionPayload, ...{remarks: value}})}}
                />
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Record Transaction`}
                    buttonAction={()=>{pushTransaction()}}
                    processing={sundriesSelector.creatingSundryTransaction}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={close}
                >
                Cancel
                </button>
            </div>
        </div>
    )
}

export default NewSundryTransaction